import { Page } from '../../components/Page/Page';
import { HeroContent } from '../../components/HeroContent/HeroContent';
import { Body2, Heading2, Join, Space } from '@gousto-internal/citrus-react';
import { composeGetServerSideProps } from '../../utils/page/composeGetServerSideProps';
import { addFeatureFlagsProp, withFeatureFlags } from '../../utils/page/featureFlags';
import { InferGetServerSidePropsType } from 'next';
import { withCustomerLoggedInProp } from '../../utils/page/auth';

export const getServerSideProps = composeGetServerSideProps(
  withFeatureFlags(addFeatureFlagsProp),
  withCustomerLoggedInProp,
);

export default function IngredientsStorage(
  props: InferGetServerSidePropsType<typeof getServerSideProps>,
) {
  return (
    <Page customerLoggedIn={props.customerLoggedIn} features={props.features}>
      <HeroContent heading="How to store your opened ingredients">
        <Join with={<Space size={6} />}>
          <Body2>
            We advise to check your ingredient packaging, this will confirm any storage instructions
            (such as “Store in a cool dry place, refrigerate once opened”), and check for a use-by
            date.
          </Body2>
          <Heading2>What if there aren’t any storage instructions on the pack?</Heading2>
          <Body2>
            For those cases where there aren’t instructions (or even packaging), here’s a general
            guide from our chefs:
          </Body2>
          <Body2>
            <strong>Fresh or chilled foods</strong> must be refrigerated. This includes meat, dairy,
            and anything else that comes in your Eco Chill Box. Once opened, return to the fridge
            and use within 1 day. Make sure you don’t exceed the use-by date printed on the
            packaging.
          </Body2>
          <Body2>
            <strong>Storecupboard items</strong> like dried pasta, rice, couscous, etc, should be
            stored in an airtight container and used within 1 week.
          </Body2>
          <Body2>
            <strong>Pastes, sauces and tinned goods</strong> like tomato paste, soy sauce and tinned
            tomatoes, should be stored in the fridge and used within 1 day.
          </Body2>
          <Body2>
            If you throw away the packaging make sure you take note of any allergen information and
            use-by date.
          </Body2>
          <Heading2>Is it possible to freeze ingredients?</Heading2>
          <Body2>
            Look on your ingredient packaging to find out whether or not you can freeze it.
          </Body2>
          <Body2>
            <strong>Please remember:</strong> Make sure you fully defrost any meat or fish in the
            fridge before cooking. Never refreeze them once defrosted, and cook them within 24 hours
            of defrosting. Refreezing foods can affect texture and food safety, so it’s really
            important to follow these guidelines carefully.
          </Body2>
        </Join>
      </HeroContent>
    </Page>
  );
}
